<template>
    <b-container fluid>
        <b-row>
            <b-col xl="12" lg="12" sm="12">
                <iq-card>
                    <template v-slot:body>
                        <b-overlay :show="formLoader">
                            <b-row>
                                <b-col xl="12" lg="12" sm="12">
                                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                        <b-form @submit.prevent="handleSubmit(storeUpdate)" @reset.prevent="reset" enctype="multipart/form-data">
                                            <b-row>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Organization Name" vid="organization_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="organization_id "
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('globalTrans.organization')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="form_data.org_id"
                                                                id="organization_id"
                                                                :options="orgList"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Institute Type" vid="institute_type_id" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="institute_type "
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('ds_config.institute_type')}}  <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                                plain
                                                                v-model="form_data.office_type_id"
                                                                id="institute_type_id"
                                                                :options="officeTypeList"
                                                                :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                                <template v-slot:first>
                                                                    <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                                </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                </b-row>
                                                <b-row>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Institute Name" vid="institute_name" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="institute_name "
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('ds_institute_management.institute_name')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                            plain
                                                            v-model="form_data.office_id"
                                                            id="institute_name"
                                                            :options="officeList"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                            <template v-slot:first>
                                                                <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                            </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Class" vid="class_id" rules="required">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="class_id "
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{$t('ds_institute_management.class')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                            plain
                                                            v-model="form_data.class_id"
                                                            id="class_id"
                                                            :options="classList"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                            <template v-slot:first>
                                                                <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                            </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                </b-row>
                                                <b-row>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Student" vid="student_name" rules="required|min_value:1">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="student_name "
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('ds_student_management.student_name')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-select
                                                            plain
                                                            v-model="form_data.applicant_id"
                                                            @change="GetD(form_data.applicant_id)"
                                                            id="institute_name"
                                                            :options="studentList"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            >
                                                            <template v-slot:first>
                                                                <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                            </template>
                                                            </b-form-select>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col v-if="isMobile" lg="6" sm="12" >
                                                    <ValidationProvider name="Contact No" vid='contact_no'>
                                                        <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="contact_no"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                            {{ $t('ds_institute_management.contact_no')}}
                                                        </template>
                                                        <b-form-input
                                                        id="contact_no"
                                                        disabled
                                                        v-model="form_data.mobile_no"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}}
                                                        </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col lg="6" sm="12">
                                                    <ValidationProvider name="Date" vid='date' rules="required">
                                                        <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="date"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                        <template v-slot:label>
                                                            {{ $t('training.date')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                        placeholder="Select Date"
                                                        id="date"
                                                        v-model="form_data.date"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col xl="6" lg="6" sm="12">
                                                   <ValidationProvider name="Therapy Center" vid="therapy_center_id" rules="">
                                                        <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="therapy_center_id "
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        {{$t('ds_config.therapy_center')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="form_data.therapy_center_id"
                                                        id="therapy_center_id"
                                                        :options="therapyCenterList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0">{{$t('globalTrans.other')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                </b-row>
                                                <!-- External School (BN) -->
                                                <b-row v-if="other">
                                                    <b-col lg="6" sm="12" >
                                                        <ValidationProvider name="Therapy Center (En)" vid='other_center_en' rules="required">
                                                        <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="other_center_en"
                                                        slot-scope="{ valid, errors }"
                                                            >
                                                        <template v-slot:label>
                                                            {{ $t('ds_student_management.other_center_en')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                        id="other_center_en"
                                                        v-model="form_data.other_center_en"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        ></b-form-input>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}}
                                                        </div>
                                                        </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                    <b-col lg="6" sm="12" >
                                                        <ValidationProvider name="Therapy Center (Bn)" vid='other_center_bn' rules="required">
                                                            <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="other_center_bn"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('ds_student_management.other_center_bn')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-input
                                                            id="other_center_bn"
                                                            v-model="form_data.other_center_bn"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            ></b-form-input>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}}
                                                            </div>
                                                            </b-form-group>
                                                        </ValidationProvider>
                                                    </b-col>
                                                </b-row>
                                                <b-row>
                                                <b-col xl="6" lg="6" sm="12">
                                                    <ValidationProvider name="remarks (En)" vid='remarks_en' rules="required">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="remarks_en"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('training.remarks_en')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-textarea
                                                            id="remarks_en"
                                                            v-model="form_data.remarks"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            rows="2"
                                                            max-rows="6"
                                                            ></b-form-textarea>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                                <b-col xl="6" lg="6" sm="12">
                                                    <ValidationProvider name="remarks (Bn)" vid='remarks_bn' rules="required">
                                                        <b-form-group
                                                            class="row"
                                                            label-cols-sm="5"
                                                            label-for="remarks_bn"
                                                            slot-scope="{ valid, errors }"
                                                        >
                                                            <template v-slot:label>
                                                                {{ $t('training.remarks_bn')}} <span class="text-danger">*</span>
                                                            </template>
                                                            <b-form-textarea
                                                            id="remarks_bn"
                                                            v-model="form_data.remarks_bn"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                            rows="2"
                                                            max-rows="6"
                                                            ></b-form-textarea>
                                                            <div class="invalid-feedback">
                                                                {{ errors[0] }}
                                                            </div>
                                                        </b-form-group>
                                                    </ValidationProvider>
                                                </b-col>
                                              </b-row>

                                            <div class="row">
                                                <div class="col-sm-3"></div>
                                                <div class="col text-right">
                                                    <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                                    &nbsp;
                                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                                </div>
                                            </div>
                                        </b-form>
                                    </ValidationObserver>
                                </b-col>
                            </b-row>
                        </b-overlay>
                    </template>
                </iq-card>
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
    import { ValidationObserver, ValidationProvider } from 'vee-validate'
    import RestApi, { disabilitySchoolServiceBaseUrl } from '@/config/api_config'
    import { studentTherapyAddApi, studentTherapyUpdateApi, getTherapyByOfficeApi, studentInfo } from '../../api/routes'
    import flatpickr from 'flatpickr'
    export default {
        props: ['id'],
        components: {
            ValidationObserver,
            ValidationProvider
        },
        created () {
            this.form_data.org_id = this.$store.state.dataFilters.orgId
            this.form_data.office_type_id = this.$store.state.dataFilters.officeTypeId
            this.form_data.office_id = this.$store.state.dataFilters.officeId
            if (this.form_data.office_id) {
                this.therapyCenterByOffice()
            }
            if (this.id) {
                const tmp = this.getInstituteInfoData()
                this.form_data = tmp
                this.form_data.class_id = tmp.student.class_id
                this.form_data.applicant_id = tmp.applicant_id
                this.form_data.date = tmp.date
                this.form_data.remarks = tmp.remarks
                this.form_data.remarks_bn = tmp.remarks_bn
                if (tmp.therapy_center_id) {
                    this.other = false
                } else {
                    this.form_data.therapy_center_id = 0
                    this.other = true
                }
            }
        },
        mounted () {
            flatpickr('#date', {})
            // core.index()
        },
        data () {
            return {
                ItemShow: false,
                formLoader: false,
                saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
                disabilitySchoolServiceBaseUrl: disabilitySchoolServiceBaseUrl,
                form_data: {
                    org_id: 0,
                    office_type_id: 0,
                    therapy_center_id: 0,
                    office_id: 0,
                    applicant_id: 0,
                    mobile_no: '',
                    other_center_bn: '',
                    other_center_en: '',
                    class_id: 0,
                    date: null,
                    remarks: null,
                    remarks_bn: null
                },
                other: true,
                officeTypeList: [],
                therapyCenterList: [],
                officeList: [],
                studentList: [],
                AllSTudent: [],
                loading: false,
                isMobile: false
            }
        },
        computed: {
            orgList: function () {
                return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
            },
            currentLocale () {
                return this.$i18n.locale
            },
            classList: function () {
                const list = this.$store.state.DisabilitySchoolService.commonObj.classList.filter(item => item.status === 1)
                return list.map(obj => {
                    if (this.currentLocale === 'en') {
                        return { value: obj.value, text: obj.text_en }
                    } else {
                        return { value: obj.value, text: obj.text_bn }
                    }
                })
            }
        },
        watch: {
            'form_data.org_id': function (newVal) {
                this.officeTypeList = this.getofficeTypeList(newVal)
            },
            'form_data.office_type_id': function (newVal) {
                this.officeList = this.getOfficeList(newVal)
            },
            'form_data.office_id': function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    if (this.form_data.class_id) {
                        this.FetchStudent()
                    }
                    this.therapyCenterByOffice()
                }
            },
            'form_data.class_id': function (newVal, oldVal) {
               if (newVal !== oldVal) {
                   this.FetchStudent()
               }
            },
            'form_data.therapy_center_id': function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    if (newVal === 0) {
                        this.other = true
                    } else {
                        this.other = false
                    }
                }
            }
        },
        methods: {
            GetD (e) {
                if (this.AllSTudent.length > 0) {
                    const element = this.AllSTudent.find(item => item.value === parseInt(e))
                    this.form_data.mobile_no = element.mobile_no
                    this.isMobile = true
                }
            },
            FetchStudent () {
                const data = {
                    office_id: this.form_data.office_id,
                    class_id: this.form_data.class_id
                }
                this.formLoader = true
                RestApi.postData(disabilitySchoolServiceBaseUrl, studentInfo, data).then(response => {
                    const info = []
                    const lng = this.$i18n.locale
                    this.AllSTudent = response.data
                    response.data.forEach(function (element, index) {
                        var t = lng === 'bn' ? element.text_bn : element.text_en
                        info.push({
                            value: element.value,
                            text: t + ' - (Roll: ' + element.student_id + ' / ' + element.mobile_no + ')',
                            item: element
                        })
                    })
                    this.studentList = info
                    // only for edit
                    if (this.id) {
                        if (this.AllSTudent.length > 0) {
                            this.GetD(this.form_data.applicant_id)
                        }
                    }
                    this.formLoader = false
                })
            },
            therapyCenterByOffice () {
                const data = {
                    org_id: this.form_data.org_id,
                    office_type_id: this.form_data.office_type_id,
                    office_id: this.form_data.office_id
                }
                this.formLoader = true
                RestApi.getData(disabilitySchoolServiceBaseUrl, getTherapyByOfficeApi, data).then(response => {
                    if (response.success) {
                        this.therapyCenterList = response.data.map(el => {
                            return Object.assign({}, el, { value: el.value, text: this.$i18n.locale === 'bn' ? el.text_bn : el.text_en })
                        })
                        // this.therapyCenterList.push({ value: 'other', text: this.$i18n.locale === 'bn' ? 'অন্যান্য' : 'Others' })
                    } else {
                        this.therapyCenterList = []
                    }
                    this.formLoader = false
                })
            },
            getTherapyCenterList (id) {
                return this.$store.state.DisabilitySchoolService.commonObj.therapyCenterList.filter(item => item.office_id === id)
            },
            getInstituteInfoData () {
                const tmpData = this.$store.state.list.find(item => item.id === this.id)
                return JSON.parse(JSON.stringify(tmpData))
            },
            async storeUpdate () {
                this.formLoader = true
                this.form_data.other = this.other
                this.$store.dispatch('mutateCommonProperties', { loading: true })
                let result = null
                const loadingState = { loading: false, listReload: false }

                if (this.id) {
                    result = await RestApi.putData(disabilitySchoolServiceBaseUrl, `${studentTherapyUpdateApi}/${this.id}`, this.form_data)
                } else {
                    result = await RestApi.postData(disabilitySchoolServiceBaseUrl, studentTherapyAddApi, this.form_data)
                }
                loadingState.listReload = true
                this.$store.dispatch('mutateCommonProperties', loadingState)
                if (result.success) {
                    this.formLoader = false
                    this.$toast.success({
                        title: this.$t('globalTrans.success'),
                        message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                        color: '#D6E09B'
                    })
                    this.$bvModal.hide('modal-4')
                } else {
                    this.$refs.form.setErrors(result.errors)
                }
            },
            getofficeTypeList (orgId = null) {
                const instituteTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0)
                if (orgId) {
                    return instituteTypeList.filter(institute => institute.org_id === orgId)
                }

                return instituteTypeList
            },
            getOfficeList (typeId = null) {
                const instituteList = this.$store.state.commonObj.officeList.filter(item => item.status === 0)
                if (typeId) {
                    return instituteList.filter(institute => institute.office_type_id === typeId)
                }

                return instituteList
            }
        }
    }

</script>
